"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientInfo = void 0;
const resource_model_1 = require("./resource.model");
class ClientInfo extends resource_model_1.Resource {
    load(x) {
        super.load(x);
        this.timestamp = this.clean(x.timestamp, t => new Date(t).toISOString());
        this.platform = this.clean(x.platform, String);
        this.screenWidth = this.clean(x.screenWidth, Number);
        this.screenHeight = this.clean(x.screenHeight, Number);
        this.isLandscape = this.clean(x.isLandscape, Boolean);
        this.url = this.clean(x.url, String);
        this.referrer = this.clean(x.referrer, String);
        this.isOnline = this.clean(x.isOnline, Boolean);
        this.language = this.clean(x.language, String);
        this.userAgent = this.clean(x.userAgent, String);
    }
}
exports.ClientInfo = ClientInfo;
